import { fetchJSON } from "./utils";

function formatTraining(training) {
  if (training == null) {
    return null;
  }

  return {
    ...training,
  };
}

// Example usage:
// My Saved Drafts - params = User_ID = logged in user id, Status = "REVIEW"
// My Trainings In Review - params = User_ID = logged in user id, Status = "PENDING"
// For my review = params - Status = "PENDING", approver_id = logged in user id
// Live - params = Status = "LIVE"
// Rejected - params = Status = "REJECTED"
//
export function fetchTrainings(params) {
  const url = "/api/trainings/";
  return fetchJSON(url, params, null, "get", false);
}

export function getTraining(id) {
  const url = `/api/trainings/${id}`;
  return fetchJSON(url, null, null, "get", false);
}

export function getTrainingByidInteractionId(interactionId) {
  const url = `/api/trainings/interaction/${interactionId}`;
  return fetchJSON(url, null, null, "get", false);
}

export async function getTrainingByInteractionId(interactionId) {
  const url = `/api/trainings/interaction/${interactionId}`;
  const resp = await fetchJSON(url, null, null, "get", false);
  return formatTraining(resp.data);

}

// example usage
// data = required fields: data = {data = "This is the new trained response", Status = "REVIEW", Interaction = "some valid interaction id "}
export async function createTraining(data) {
  const url = "/api/trainings/";
  const resp = await fetchJSON(url, null, data, "post");
  return formatTraining(resp.data);
}

export async function updateTraining(id, data) {
  const url = `/api/trainings/${id}`;
  const resp = await fetchJSON(url, null, data, "put");
  return formatTraining(resp.data);
}
